"use client";

import { Check, Copy } from "@/components/icons";
import { Button } from "@/components/ui/button";
import { useCopyToClipboard } from "@/hooks/use-copy-to-clipboard";
import { cn } from "@/lib/utils";

interface CodeBlockProps {
  value: string;
  copyLabel: string;
  className?: string;
}

export function CodeBlock({ value, copyLabel, className }: CodeBlockProps) {
  const { copy, copied } = useCopyToClipboard();
  return (
    <div className={cn("relative", className)}>
      <pre className="overflow-x-auto rounded-sm border bg-surface-2 p-3 pr-12 font-mono text-xs leading-relaxed">
        {value}
      </pre>
      <Button
        variant="ghost"
        size="icon-sm"
        className="absolute right-1.5 top-1.5"
        aria-label={copyLabel}
        onClick={() => void copy(value, `${copyLabel} copied`)}
      >
        {copied ? (
          <Check className="h-4 w-4 text-success-strong" />
        ) : (
          <Copy className="h-4 w-4" />
        )}
      </Button>
    </div>
  );
}
